/**
 * Ryan O'Dowd
 * 2025-12-14
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({globalScale, colors, isDarkMode}) => {
  return {
    dialogText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      fontSize: globalScale * 14,
      color: colors.dialogText,
      paddingBottom: 12,
    },
    httpLink: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      color: isDarkMode ? colors.accentLight : colors.accentDark,
      textDecorationLine: 'underline',
    },
    previewButton: {
      marginTop: 8,
    },
    spacer: {
      flexGrow: 1,
    },
  };
};

export default getStyles;
